import Navbar from './Navbar'
import Footer from './Footer'

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-brand-cream font-body">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}
